import { NGNIcon, CADIcon } from '.'

export const CurrencyIcons = {
  NGN: NGNIcon,
  CAD: CADIcon,
}
